import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

export const memberConfig: MemberPageConfig = {
  theme: {
    avatarBorder: 'rgba(255,255,255,.7)',
    btnPrimaryBg: '#FFFFFF',
    topUpBtnBg: 'linear-gradient(135deg, #F492AC 0%, #E05A7E 100%)',
    vipSubscribeBg: 'linear-gradient(120deg, #3A2A33 0%, #5C3A4A 100%)',
    subscribeBg: 'linear-gradient(120deg, #3A2A33 0%, #5C3A4A 100%)',
    subscribeText: '#EFCE7A',
    subscribeText2: 'rgba(255,255,255,.76)',
    vipBtnBg: 'linear-gradient(135deg, #EFCE7A 0%, #C9A227 100%)',
    userNameColor: '#FFFFFF',
    userIdColor: 'rgba(255,255,255,.82)',
  },
  resources: {
    memberBg: '',
    userBg: '/images/novelyn/member-bg.svg',
    userDefaultAvatar: '/images/novelyn/user-default.svg',
    memberVip: '/images/novelyn/vip.svg',
    memberVipDiscount: '/images/novelyn/vip.svg',
  },
  texts: memberCommonConfig.texts,
}
